<template>
  <div class="drawer-detail">
    <div class="search-row">
      <span class="label">对接HR:</span>
      <span v-for="(hr, k) in project.contact" :key="k" class="link-text" @click="showRadish(hr.rid)">{{hr.姓名}}</span>
    </div>
    <div class="field-type">
      <span class="label">{{translateTag['一句话简介']||'一句话简介'}}:</span>
      <div :class="[company['一句话简介']?'':'gray-text','value company-pre']">
        <p v-if="company['一句话简介']">{{company['一句话简介']}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('一句话简介')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <div class="field-type">
      <span class="label">{{translateTag['公司亮点']||'公司亮点'}}:</span>
      <div :class="[company['公司亮点']&&company['公司亮点'].content?'':'gray-text','value company-pre']">
        <p v-if="company['公司亮点']&&company['公司亮点'].content">{{company['公司亮点']&&company['公司亮点'].content}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('公司亮点')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <div v-if="hasCognize" class="field-type">
      <div class="cognize-box">
        <span v-for="field in cognizeFields"  :key="field">{{translateTag[field]||field}}:{{company[field] }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    company: { type: Object, default: () => ({}) },
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['一句话简介', '公司介绍','人员受认可度', '固定薪酬', '激励机制', '人员稳定性'],
      translateTag: {
        一句话简介: '一句话介绍',
      },
    }
  },
  computed: {
    hasCognize() {
      const fields = ['人员受认可度', '固定薪酬', '激励机制', '人员稳定性']
      let flag = false
      for(const field of fields){
        if(this.company[field]) flag = true
      }
      return flag
    },
    cognizeFields(){
      const fields = ['人员受认可度', '固定薪酬', '激励机制', '人员稳定性']
      const arr = fields.filter(v=>this.company[v])
      return arr
    },
  },
  methods: {
    showRadish(id) {
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
    quickEdit(field){
      const { translateTag, company } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:field==='公司亮点'?'tagInput':'input',
        noTag:true,
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.cognize-box{
  display: flex;
  flex-wrap:wrap;
}
.cognize-box span{
  display: inline-block;
  min-width: 50%;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
